/**
 * ApiClient
 * axiosのラッパー関数
 */

import axios from '../../node_modules/axios';

// エラーハンドリング関数
// 下記のステータスコードを参考にAPIのレスポンスを作成
// 失敗モーダル表示など共通処理が出てきたら記述
const handleError = (status) => {
  // ステータス毎に処理を変更 - https://developer.mozilla.org/ja/docs/Web/HTTP/Status
  switch (status) {
    case '200': // リクエスト成功
    case '201': // 作成成功
    case '204': // 削除成功
      /*
      console.error('status >= 200 && status < 300で例外発生');
      */
      break;
    case '301': // リダイレクト
    case '304': // キャッシュされている
    case '400': // 不正なパラメータ
    case '401': // 認証失敗
    case '403': // 認証エラーによるレスポンス拒否
    case '404': // リソースが見つからない
    case '409': // リクエストの矛盾（同一primaryKeyの登録など）
    case '500': // 想定しないサーバーエラー
    case '501': // HTTPメソッドが不正（想定しないHTTPメソッド）
    case '502': // サーバー側のレスポンスが不正
    case '503': // サーバーダウン
    case '504': // サーバーのタイムアウト
/*
 必要に応じて「リクエストが失敗しました」的なモーダルを表示する
 console.error('リクエストが失敗');
 */
      break;
    default:
      break;
  }
};

const modifyMethodGroup = ['post', 'put', 'patch', 'delete'];

// axiosの設定 - application_xxxから1度だけ呼び出す
export const apiSetting = (config = {}) => {
  axios.defaults.timeout = config.CONST.API.TIMEOUT;
  axios.defaults.baseURL = config.CONST.API.BASE_URL;

  _.forEach(modifyMethodGroup, (method) => {
    axios.defaults.headers[method]['Content-Type'] = 'application/x-www-form-urlencoded';
  });

  // respond_toの複数format対応
  axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';

  // Authorizationヘッダを利用する場合(jwtなど)
  /*
   axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
  */

  /*
   axios.defaults.withCredentials = true;
  */
};

export default (params = {}) => {
  const reformatParams = {
    method: params.method || 'get',
    url: params.url || '',
    headers: params.headers || {},
    // body params
    data: params.data || {},
    // query params
    params: params.params || {},
    // options are 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
    responseType: params.responseType || 'json',
    // デフォルトは200 <= status < 300 でresolve
    validateStatus: params.validateStatus || axios.defaults.validateStatus,
    // リクエストキャンセル - https://github.com/mzabriskie/axios#cancellation
    cancelToken: params.cancelToken || null,
    // 成功時の共通処理を握りつぶすコールバック
    success: params.success || null,
    // 失敗時の共通処理を握りつぶすコールバック
    error: params.error || null,
    // 成功時にpublishしたい内容
    /*
     publish: params.publish || null,
    */
  };

  if (params.contentType === 'json') {
    reformatParams.headers = _.extend(reformatParams.headers, {
      'Content-Type': 'application/json',
    });
  }

  /*
   _.forEach(modifyMethodGroup, method => {
     if (params.method === method) {
       // CSRFトークンの付与
       const token = DIVER.$('[name=csrf-token]').attr('content')[0];
       reformatParams.headers = _.extend(reformatParams.headers, {
         'X-CSRF-TOKEN': token
       });
     }
   });
  */

  // レスポンスの前処理
  // interceptorsは複雑になるため利用しない
  return axios(reformatParams)
  .then((response) => {
    let ret;
    if (params.success) {
      ret = params.success(response);
    } else {
      // 共通のデータ加工処理はここに記述
      ret = response.data;
    }
    return ret;

    /*
     if (params.publish) {
       PubSub.publish(params.publish, response);
     }
    */
  })
  .catch((error) => {
    if (params.error) {
      params.error(error);
    } else {
      // 共通のエラーハンドリング
      handleError(error.response.status);
      throw error.response.data;
    }
  });
};



// WEBPACK FOOTER //
// ./src/utility/api_client.js